export const skyBlueColor = '#59B2E0';
export const lightOrangeColor = '#f0af7e';
